import React from 'react'

function Hero() {
    return (
        <>
        <div className="container pt-5 mb-5">
            <div className="row mt-5 pt-5 text-center mb-5">
                <h3>Zerodha Products</h3>
                <p className='fs-4 text-muted'>Sleek, modern, and intuitive trading platforms</p>
                <p className='fs-5 text-muted'>Check out our investment offerings →</p>
            </div>
        </div>
        </>
    )
}

export default Hero
